import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { HomePage } from '@/components/infoPages/HomePage'

const LoginRouteComponent = () => {
  const { openLoginDialog } = useAuth()
  useEffect(() => {
    openLoginDialog()
  }, [openLoginDialog])
  return <HomePage />
}

export const Route = createFileRoute('/auth/login')({
  component: LoginRouteComponent,
})
